import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import {LabelContainerModel, LabelListContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import {ApiResponseModel, ApiVisa} from "../../shared";
import {LabelCriteriaModelQuery, LabelQueryCriteriaClass} from "../../../criteria";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LabelListService extends BaseApiPublicLoginTemplateService<LabelListContainerModel, LabelListContainerModel, LabelListContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'label-lists';
  static readonly LABEL_LIST_SUB_PATH = 'label-lists/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'label-lists';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'label-lists';
    this.httpClient = http;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + LabelListService.LABEL_LIST_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + LabelListService.LABEL_LIST_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
  }
  getByCriteriaObservable(
    visa: ApiVisa, criteria?: LabelQueryCriteriaClass
  ): Observable<ApiResponseModel<LabelListContainerModel>> {
    const buildDocCriteria = new LabelCriteriaModelQuery(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<LabelListContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa));
  }
}
